import React, { useState, useContext } from "react";
import { createTheme } from "@material-ui/core/styles";
import "date-fns";
import moment from "moment";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@material-ui/core/Button";
import Plane from "../../SVG/Plane";
import Sea from "../../SVG/Sea";
import RoadSVG from "../../SVG/RoadSVG";
import RailSVG from "../../SVG/RailSVG";
import CourierSVG from "../../SVG/CourierSVG";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/date-fns";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const materialTheme = createTheme({
  palette: {
    primary: {
      main: "rgba(var(--text-heading-light))",
    },
  },
});

function AdvSearchDashboard(props) {
  const [transportModeType, setTransportModeType] = useState(null);
  const [modeValue, setModeValue] = useState("");
  const [containerModeValue, setContainerModeValue] = useState([]);
  const [dateTypeValue, setDateTypeValue] = useState("");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const transportModeOption = [
    {
      name: "Air",
      value: "AIR",
      icon: <Plane colorCode={"rgba(var(--text-heading-dark))"} />,
      type: ["LSE", "ULD", "CON", "BCN"],
    },
    {
      name: "Sea",
      value: "SEA",
      icon: <Sea colorCode={"rgba(var(--text-heading-dark))"} />,
      type: ["FCL", "LCL", "BLK", "LQD", "BBK", "BCN", "ROR"],
    },
    {
      name: "Road",
      value: "ROA",
      icon: <RoadSVG colorCode={"rgba(var(--text-heading-dark))"} />,
      type: ["LTL", "BCN", "LCL"],
    },
    {
      name: "Rail",
      value: "RAI",
      icon: <RailSVG colorCode={"rgba(var(--text-heading-dark))"} />,
      type: ["LCL", "BLK", "LQD", "BBK", "BCN", "ROR"],
    },
    {
      name: "Courier",
      value: "COU",
      icon: <CourierSVG colorCode={"rgba(var(--text-heading-dark))"} />,
      type: ["OBC", "UNA"],
    },
  ];

  const handleChangeDateFrom = (date) => {
    setDateFrom(date);
  };

  const handleChangeDateTo = (date) => {
    setDateTo(date);
  };

  const resetFilters = () => {
    setModeValue("");
    setDateTypeValue("");
    setDateFrom(null);
    setDateTo(null);
    setTransportModeType(null);
    setContainerModeValue([]);
  };

  const handleChangeDateType = (event) => {
    setDateTypeValue(event.target.value);
  };

  const filterSearch = () => {
    props.close();
    let firstDate = dateFrom ? moment(dateFrom).format("DD/MM/YYYY") : "";
    let lastDate = dateTo ? moment(dateTo).format("DD/MM/YYYY") : "";
    let containerSearchData = containerModeValue.length
      ? containerModeValue.join(",")
      : "";
    let finaldate =
      firstDate && lastDate
        ? `${firstDate} - ${lastDate}`
        : firstDate
        ? `${firstDate}`
        : lastDate
        ? `${lastDate}`
        : "";
    if (dateTypeValue === "ETA") {
      props.apiCall(modeValue, containerSearchData, finaldate, "");
    } else if (dateTypeValue === "ETD") {
      props.apiCall(modeValue, containerSearchData, "", finaldate);
    } else {
      props.apiCall(modeValue, containerSearchData, "", "");
    }
  };

  return (
    <div>
      <div>
        <FormControl sx={{ m: 1, width: 300 }}>
          <InputLabel>Transport Mode</InputLabel>
          <Select
            value={modeValue}
            className="selectTransportModeFilter"
            onChange={(event, value, index) => {
              setModeValue(event.target.value);
              setContainerModeValue([]);
              setTransportModeType(transportModeOption[value.props.index].type);
            }}
            input={<OutlinedInput label="Transport Mode" />}
          >
            {transportModeOption.map((element, index) => (
              <MenuItem
                key={index}
                className="selectTransportModeFilter"
                value={element.value}
                index={index}
              >
                {" "}
                {element.icon}
                {element.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      {transportModeType && transportModeType.length ? (
        <div className="TransportOptionsTwo">
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={transportModeType}
            value={containerModeValue}
            onChange={(event, newValue) => {
              setContainerModeValue(newValue);
            }}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Container Type"
                placeholder="Container Type"
              />
            )}
          />
        </div>
      ) : null}
      <RadioGroup
        className="dateFilter"
        name="dateFilter"
        value={dateTypeValue}
        onChange={handleChangeDateType}
      >
        <FormControlLabel
          value="ETA"
          control={<Radio color="primary" />}
          label="ETA"
        />
        <FormControlLabel
          value="ETD"
          control={<Radio color="primary" />}
          label="ETD"
        />
      </RadioGroup>
      {dateTypeValue === "ETA" || dateTypeValue === "ETD" ? (
        <div className="DateFilter">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={materialTheme}>
              <DatePicker
                className="etdFilter"
                maxDate={new Date()}
                clearable
                id="etdFilter"
                placeholder="Date from"
                format="dd/MM/yyyy"
                value={dateFrom}
                onChange={handleChangeDateFrom}
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={materialTheme}>
              <DatePicker
                className="etaFilter"
                minDate={dateFrom}
                clearable
                id="etaFilter"
                placeholder="Date to"
                format="dd/MM/yyyy"
                value={dateTo}
                onChange={handleChangeDateTo}
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </div>
      ) : null}

      <div className="modalFooter mt-3">
        <Button variant="contained" onClick={resetFilters}>
          Reset
        </Button>
        <Button variant="contained" onClick={filterSearch}>
          Apply
        </Button>
      </div>
    </div>
  );
}

export default AdvSearchDashboard;
